import {
    EXPERTISES_VENDOR_FETCHING,
    EXPERTISES_VENDOR_FAILED,
    EXPERTISES_VENDOR_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case EXPERTISES_VENDOR_FETCHING:
            return {...state, result: null, isFetching: true, isError: false};
        case EXPERTISES_VENDOR_FAILED:
            return {...state, result: null, isFetching: false, isError: true};
        case EXPERTISES_VENDOR_SUCCESS:
            return {...state, result: payload, isFetching: false, isError: false};
        default:
            return state;
    }
};
